import { helpers } from '../helpers.js';

var register = {
	selectors: { },

	init: function () {
		const self = this;

		self.hookForms();
	},

	hookForms: function() {
		if( ! jQuery('form.pctforms') ) {
			return false;
		}

		jQuery( 'form.pctforms' ).on( 'submit', function(event) {
			event.preventDefault();

			// empy previous response
			jQuery( this ).find( '.pctforms__response' ).html( '' );
	
			// Get all form data
			var formData = jQuery(this).serializeArray();
			var data = {
				'action': 'process_pct_form' // default
			};
	
			// Convert formData to key-value pairs
			jQuery.each(formData, function(i, field) {
				data[ field.name ] = field.value;
			});
	
			// Make the API call
			helpers.pctApiCall(data).then(response => {
				console.log( response );
				jQuery( this ).find( '.pctforms__response' ).html( response.data.message );
			}).catch(error => {
				// jQuery( this ).find( '.pctforms__response' ).html( response.data.message );
				console.error('Error: ', error);
			});
		});
	}
};

export { register };